<!-- Table Actions -->
<div class="table-action-bar">
  <!-- Other Actions: -->
  <ng-content></ng-content>
  <!-- Toggle Columns -->
  <button
    type="button"
    class="btn btn-link btn-primary btn-sm ml-3"
    (click)="toggleColumns.emit()">
    <span><i class="fa fa-columns" aria-hidden="true"></i></span>
    Toggle Columns
  </button>
</div>
